import { ICreateStudioState } from './createStudioModalContext';
import { CreateStudioActionTypes, TCreateStudioAction } from '../createStudioModalActions';

export const createStudioReducer = (state: ICreateStudioState, action: TCreateStudioAction): ICreateStudioState => {
	switch (action.type) {
		case CreateStudioActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateStudioActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateStudioActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
